import { createSelector } from '@reduxjs/toolkit';

import { logDevMessage } from 'utils/utils';
import type { ReduxSelector } from 'store/store.types';
import tooltipSlice from './tooltipSlice';
import type { TooltipSliceState } from './tooltip.types';

export const getTitle: ReduxSelector<string | null> = (state) => state[tooltipSlice.name].title;
export const getMessage: ReduxSelector<string | null> = (state) => state[tooltipSlice.name].message;
export const getLink: ReduxSelector<TooltipSliceState['link']> = (state) =>
  state[tooltipSlice.name].link;
export const getHref: ReduxSelector<TooltipSliceState['href']> = (state) =>
  state[tooltipSlice.name].href;
export const getTooltipState: ReduxSelector<TooltipSliceState> = (state) =>
  state[tooltipSlice.name];
export const isMarkdown: ReduxSelector<boolean> = (state) => state[tooltipSlice.name].isMarkdown;
export const isOpen: ReduxSelector<boolean> = createSelector([getMessage], (message) =>
  Boolean(message)
);
export const linkPresent: ReduxSelector<string | null> = createSelector(
  getLink,
  (link) => link.to && link.label
);
export const renderHref: ReduxSelector<TooltipSliceState['href'] | null> = createSelector(
  [getTooltipState],
  (state) => {
    // if an href and internal link are passed into tooltip, only return href and issue a warning
    if (state.link.to && state.href.to) {
      logDevMessage(
        'Href and link.href props simultaneously given to component. Link.href will be overridden by the Href'
      );
      return state.href;
    }

    return state.href.to && state.href.label ? state.href : null;
  }
);
